export function nullableString(opts = {}){
  return (value)=>{
    return typeof value === 'string' || value === null || value === undefined
  }
}
